import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/helpChat.tsx
var HelpChat = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M8.5 18.9492H8C4 18.9492 2 17.9521 2 12.9671V7.98205C2 3.99402 4 2 8 2H16C20 2 22 3.99402 22 7.98205V12.9671C22 16.9551 20 18.9492 16 18.9492H15.5C15.19 18.9492 14.89 19.0987 14.7 19.348L13.2 21.342C12.54 22.2193 11.46 22.2193 10.8 21.342L9.3 19.348C9.14 19.1286 8.77 18.9492 8.5 18.9492Z",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeMiterlimit: "10",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M12.0001 11.4034V11.2058C12.0001 10.5659 12.3991 10.2272 12.7981 9.95428C13.1876 9.6908 13.577 9.35206 13.577 8.73101C13.577 7.86531 12.8741 7.16895 12.0001 7.16895C11.1261 7.16895 10.4231 7.86531 10.4231 8.73101",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M11.9956 13.6521H12.0042",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round"
		})
	] }) : /* @__PURE__ */ jsx("path", {
		d: "M17 2C19.76 2 22 4.23108 22 6.98242V13.9658C22 16.7172 19.76 18.9482 17 18.9482H15.5C15.1901 18.9482 14.8902 19.0986 14.7002 19.3486L13.2002 21.3398C12.5402 22.2203 11.4598 22.2203 10.7998 21.3398L9.2998 19.3486C9.12977 19.1286 8.76995 18.9482 8.5 18.9482H7C4.24 18.9482 2 16.7172 2 13.9658V6.98242C2.00004 4.23108 4.24002 2 7 2H17ZM11.9961 12.9834C11.6026 12.9834 11.2833 13.2988 11.2832 13.6885C11.2832 14.0782 11.6026 14.3945 11.9961 14.3945H12.0049C12.398 14.3941 12.7168 14.078 12.7168 13.6885C12.7167 13.299 12.398 12.9838 12.0049 12.9834H11.9961ZM12 6.5C10.7327 6.50022 9.71106 7.51238 9.71094 8.76758C9.71094 9.15735 10.0303 9.47363 10.4238 9.47363C10.8169 9.47316 11.1357 9.15706 11.1357 8.76758C11.1359 8.29185 11.5198 7.91135 12 7.91113C12.4802 7.91139 12.8651 8.29187 12.8652 8.76758C12.8652 8.91586 12.8235 9.01113 12.7617 9.09375C12.6879 9.19239 12.5721 9.28936 12.3965 9.4082L12.3936 9.41016C11.9612 9.70588 11.2883 10.2291 11.2881 11.2422V11.4404C11.2882 11.8299 11.6068 12.1453 12 12.1455C12.3932 12.1452 12.7127 11.8299 12.7129 11.4404V11.2422C12.713 11.0845 12.7573 10.9864 12.8213 10.9014C12.8984 10.799 13.0176 10.6996 13.2021 10.5732C13.6326 10.2819 14.29 9.75808 14.29 8.76758C14.2899 7.5124 13.2672 6.50026 12 6.5Z",
		fill: "currentColor"
	})
});
//#endregion
export { HelpChat };
